import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from "react-redux";
import useAdvertisingTrigger from '../hooks/useAdvertisingTrigger';
import prepareAdvertising from '../utils/prepareAdvertising';
import { Loader, Header, Hero, Footer, WhatsApp, ScrollHandler, Notification, ScrollToTop, Advertising } from '../components';
import config from '../config/main.json';

function Layout({ children }) {
  const advertising = useSelector((state) => state.advertising);
  const location = useLocation();

  const preparedAdvertising = prepareAdvertising(advertising)
  const { shouldShow, markAsSeen, activeAd } = useAdvertisingTrigger(preparedAdvertising)

  return(
    <React.Fragment>
      <Loader />
      <Notification />
      <WhatsApp
        phone={config.whatsApp}
      />
      <Advertising
        isOpen={shouldShow}
        data={activeAd}
        onClose={markAsSeen}
      />
      <ScrollHandler 
        location={location}
      />
      <div id="main-panel">
        <Header />
        <Hero
          id="hero"
          color={'rgba(104, 76, 26, 0.85)'}
        />
        {children}
        <Footer
          id="footer" 
        />
        <ScrollToTop />
      </div>
    </React.Fragment>
  )
}

export default Layout